var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Title',{attrs:{"title":_vm.titleText,"subtitle":_vm.subtitleText}}),_c('Carousel',{attrs:{"small":_vm.smallCarousel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }